<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <!--<span> {{this.$router.path}} 科別介紹 建置中...</span>-->
    <v-layout row wrap xs12 sm12 md12 lg12 ml-2 mr-2 pl-2>

        <!--醫師介紹-->
        <v-flex class="xs12 sm12 md12 lg12 pl-1 mt-1 row--dense">

            <v-flex :class="['xs12 sm12 md12 row--dense',$vuetify.breakpoint.smAndDown?'row wrap':'d-inline-flex']">
                <v-flex :class="['text-center row--dense mt-2',$vuetify.breakpoint.smAndDown?'xs12 sm12 md5':'xs5 sm5 md5']"   style="text-decoration: underline;font-size: 1.5rem" >
                    <span >醫師介紹</span>
                </v-flex>
                <v-flex xs6 sm6 md7 pl-2 row--dense>
                    <v-text-field class="v-input--dense" hide-details outlined placeholder="輸入醫師姓名" label="查詢醫師" type="text" v-model="doctor"  clearable @keyup.enter="axios_getDoctorListData(doctor)"></v-text-field>
                </v-flex>
                <v-btn class="regFRBtn ml-2"   @click="axios_getDoctorListData (doctor)"> <v-icon>mdi-magnify</v-icon>查詢</v-btn>
               <!--<v-flex class="xs12 sm4 md2 pl-2"> <v-text-field   class="ml-2 inputResult" v-show="totalResult.length>0"  hide-details readonly v-model="totalResult"></v-text-field> </v-flex>-->
            </v-flex>


            <!--<v-flex xs12 sm12 md6 :style="{textDecoration:'underline',fontSize:'1.5rem',textAlign:$vuetify.breakpoint.smAndDown?'center':'right'}" style="text-decoration: underline;font-size: 1.2rem"  class="labelFont">-->
                <!--<span >醫師介紹</span>-->
            <!--</v-flex>-->

            <v-alert :value="noDataFound" type="info">
                查無資料
            </v-alert>

            <v-row   class="xs12 sm12 md12 lg12 row--dense">
                <v-col  cols="12" sm="12" md="4" lg="4"  v-for="(item,index) in doctorList" :key="index" class="elevation-3 mx-1 my-1 doctor" > <!-- 110/10/01 shs.css 專用 .doctor @media -->

                    <!--2021/10/18 改用元件化-->
                   <doctor-card-c :zone-name-list="zoneNameList" :item="item" :clinic-theme="clinicTheme"></doctor-card-c>
                    <!--版本A-->
                    <!--<v-flex-->
                            <!--class="mx-auto divHospDoc"-->
                            <!--max-width="344"-->

                    <!--&gt;-->
                        <!--<v-flex text-center>-->
                            <!--<div class="headline text-center hospDocHeader hospDocHeaderHide">{{item.empName}} <br/> {{item.empDoc}}</div>-->
                            <!--<v-list-item-avatar-->
                                    <!--class="docImage"-->
                                    <!--style="vertical-align: center"-->
                                    <!--tile-->
                                    <!--size="100"-->
                            <!--&gt;-->
                                <!--<v-img-->
                                        <!--class="elevation-6"-->
                                        <!--:src="item.empImage==''||item.empImage==undefined?defaultIcon:item.empImage"-->
                                <!--&gt;</v-img>-->

                            <!--</v-list-item-avatar>-->
                        <!--</v-flex>-->

                        <!--<v-list-item three-line>-->
                            <!--<v-list-item-content>-->
                                <!--<div class="headline text-center hospDocHeader hospDocHeaderTitle">{{item.empName}}</div>-->
                                <!--<div style="white-space: pre-line" v-html="item.empExper"></div> &lt;!&ndash;經歷&ndash;&gt;-->
                                <!--<div style="white-space: pre-line" v-html="item.empDoc"></div> &lt;!&ndash;介紹&ndash;&gt;-->
                            <!--</v-list-item-content>-->
                        <!--</v-list-item>-->


                        <!--&lt;!&ndash;<v-expansion-panels focusable>&ndash;&gt;-->
                        <!--&lt;!&ndash;<v-expansion-panel>&ndash;&gt;-->
                        <!--&lt;!&ndash;<v-expansion-panel-header class="text-center">{{item.empName}}</v-expansion-panel-header>&ndash;&gt;-->
                        <!--&lt;!&ndash;<v-expansion-panel-content>&ndash;&gt;-->
                        <!--&lt;!&ndash;<div style="white-space: pre-line" v-html="item.empExper"></div> &lt;!&ndash;經歷&ndash;&gt;&ndash;&gt;-->
                        <!--&lt;!&ndash;<div style="white-space: pre-line" v-html="item.empDoc"></div> &lt;!&ndash;介紹&ndash;&gt;&ndash;&gt;-->
                        <!--&lt;!&ndash;</v-expansion-panel-content>&ndash;&gt;-->
                        <!--&lt;!&ndash;</v-expansion-panel>&ndash;&gt;-->
                        <!--&lt;!&ndash;</v-expansion-panels>&ndash;&gt;-->


                        <!--<v-flex class="text-center mt-2 mb-2">-->
                            <!--<v-btn class="regFRBtn" @click="regDocClick(item)">預約掛號</v-btn>-->

                        <!--</v-flex>-->

                    <!--</v-flex>-->


                    <!--版本C-->
                    <!--<v-flex-->
                            <!--class="mx-auto divHospDoc3"-->
                            <!--outlined-->
                    <!--&gt;-->


                        <!--<v-list-item three-line>-->

                            <!--<v-layout row wrap xs12 sm12 md12 lg12>-->
                                <!--<v-flex xs3 sm3 md3 lg3 >-->
                                    <!--<v-list-item-content>-->

                                        <!--<v-img-->
                                                <!--class="elevation-6"-->
                                                <!--style="object-fit: cover;"-->
                                                <!--:src="item.empImage==''||item.empImage==undefined?defaultIcon:item.empImage">-->

                                        <!--</v-img>-->

                                        <!--&lt;!&ndash;</v-list-item-avatar>&ndash;&gt;-->

                                        <!--<v-btn class="regFRBtn" @click="regDocClick(item)">預約掛號</v-btn>-->
                                        <!--<v-flex class="text-center"><div style="color: #a39a9a">{{item.zoneName}}</div></v-flex>-->
                                    <!--</v-list-item-content>-->
                                <!--</v-flex>-->

                                <!--<v-flex xs9 sm9 md9 lg9 pl-2>-->
                                    <!--<v-list-item-content>-->


                                        <!--<v-flex>-->
                                            <!--<div class="headline text-center hospDocHeader3 ">{{item.empTitlename}} <br/> {{item.empName}} </div>-->
                                        <!--</v-flex>-->
                                        <!--<div style="white-space: pre-line" v-html="item.empDoc"></div> &lt;!&ndash;介紹&ndash;&gt;-->
                                        <!--<div style="white-space: pre-line" v-html="item.empExper"></div> &lt;!&ndash;經歷&ndash;&gt;-->


                                    <!--</v-list-item-content>-->

                                <!--</v-flex>-->
                            <!--</v-layout>-->


                        <!--</v-list-item>-->


                    <!--</v-flex>-->

                </v-col>

            </v-row>

        </v-flex>

        <v-dialog
                v-model="docLoading"
                hide-overlay
                persistent
                width="300"
        >
            <v-card
                    color="toolbar"
                    dark
            >
                <v-card-text>
                   {{loadingText}}
                    <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>



    </v-layout>
</template>

<script>
    import DoctorCardC from './DoctorCardC'
    export default {
        name: "DoctorIntroduction",
        components:{
            DoctorCardC
        },
        data() {
            return {
                zoneNameList:[],
                totalResult:'',
                noDataFound:false,
                loadingText:'資料載入中...',
                doctor:'',
                clinicTheme:'ClinicA',
                doctorList:[],
                docLoading:false,
                defaultIcon:'data:image/png;base64,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',
            }
        },
        created(){
            this.axios_getSysTheme();
            this.axios_getDoctorListALLData();
            this.axios_getZoneNameALL();
        },
        watch: {

        },
        methods:{
            axios_getZoneNameALL (){  //查詢院區名稱
                this.zoneNameList =[];
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "zoneset/datasearch/primarykeys/ALL";
                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.zoneNameList = response.data.resultSet;
                    }else{
                        this.zoneNameList =[];
                    }
                }).catch(error =>  {
                    this.zoneNameList =[];
                    try {
                        console.log(error.response.data.status);

                    } catch(err) {
                        console.log(err.toString())
                    }
                });
            },
            regDocClick(item){
                // this.$router.push({name: this.clinicTheme, params:{divCode:item.divNo}, query: {empNo:item.empNo,zone:item.zone}});
                this.$router.push({name: this.clinicTheme, query: {empNo:item.empNo,zone:item.zone}}); //不分科別 依醫師代號和院區搜尋
            },
            axios_getDoctorListALLData (){ //查詢醫師簡介全部清單
                this.docLoading = true;
                this.doctorList = [];
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "iregdoctor/datasearch/bydivno/ALL/ALL";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.doctorList = response.data.resultSet;
                        this.docLoading = false;
                    }else{
                        this.doctorList = [];
                        this.docLoading = false;
                    }
                }).catch(error =>  {
                    this.docLoading = false;
                    try {
                        console.log(error.response.data.status);
                        this.doctorList = [];
                    } catch(err) {
                        this.doctorList = [];
                    }
                });
            },
            axios_getDoctorListData (empName){ //查詢醫師簡介全部清單
                if(empName==''||empName==' '||empName==null){
                    alert('請輸入醫師姓名')
                    return ;
                }
                this.docLoading = true;
                this.noDataFound = false;
                this.doctorList = [];
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "iregdoctor/datasearch/byempnamelike/"+empName;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.doctorList = response.data.resultSet;
                        this.docLoading = false;
                        this.totalResult = '共 '+this.doctorList.length+" 筆"
                    }else{
                        this.doctorList = [];
                        this.docLoading = false;
                        this.noDataFound = true;
                        this.totalResult = '共 '+this.doctorList.length+" 筆"
                    }
                }).catch(error =>  {
                    this.docLoading = false;
                    try {
                        console.log(error.response.data.status);
                        this.doctorList = [];
                        this.totalResult = '';
                    } catch(err) {
                        this.doctorList = [];
                        this.totalResult = '';
                    }
                });
            },
            //查詢樣式 1100113
            axios_getSysTheme (){ //查詢樣式theme設定檔
                let url = '';
                this.clinicTheme = 'ClinicA';
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/BASEINFO/THEME";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.clinicTheme = response.data.resultSet[0].value3;

                    }else{
                        this.clinicTheme = 'ClinicA';
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.clinicTheme = 'ClinicA';
                    } catch(err) {
                        this.clinicTheme = 'ClinicA';
                    }

                });


            },
        }
    }
</script>

<style scoped>

    input .inputResult{
        font-size: 1.5rem!important;
    }


</style>